import React from 'react';
import { Grid } from '@mui/material';

const Dashboard = () => (
  <div data-testid='dashboard'>
    <Grid container spacing={4}>
      <h4>داشبورد مدیریت ادمین</h4>
    </Grid>
  </div>
);

export default Dashboard;
